import axios, { AxiosInstance } from 'axios';
import { apiConfig } from '@/config/apiConfig';
import { getVoiceFallbackClient } from './_shared';
import type { SavedSegment } from './segments';

// ── Segment Dialing (/api/outbound/campaigns/from-segment) — database reactivation ─

export type CreateScheduledCampaignFromSegmentInput = {
  campaign_id: string;
  /** A real SavedSegment id — backend resolves its full criteria query
   * server-side. Mutually exclusive with segment_attribute/segment_value.
   * Confirmed live 2026-08-21. */
  segment_id?: string;
  /** Legacy CSV-column-tag match against uploaded contacts. Ignored when
   * segment_id is set; segment_value is required when segment_id is not set. */
  segment_attribute?: string;
  segment_value?: string;
  schedule_type?: 'one_time' | 'recurring';
  drop_datetime: string;
  recurrence_rule?: string;
  time_window_start?: number;
  time_window_end?: number;
  day_of_week_windows?: Record<string, [number, number]>;
  timezone?: string;
  concurrency_limit?: number;
  max_attempts_per_contact?: number;
  min_retry_gap_hours?: number;
};

export type ScheduledCampaignResult = {
  id: string;
  campaign_id: string;
  status: string;
  contacts_total: number;
  already_scheduled?: boolean;
  /** Null for the legacy segment_attribute/segment_value mode — confirmed live 2026-08-21. */
  segment_id?: string | null;
};

export async function createScheduledCampaignFromSegment(
  input: CreateScheduledCampaignFromSegmentInput,
  axiosInstance?: AxiosInstance,
): Promise<ScheduledCampaignResult> {
  const client = axiosInstance || getVoiceFallbackClient();
  const response = await client.post<ScheduledCampaignResult>(
    `${apiConfig.voiceEndpoints.outbound}/campaigns/from-segment`,
    input,
  );
  return response.data;
}
